import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedAdminEmployeesIndexController extends Controller {
  @tracked search = '';
  @tracked sort = '-created-at';
  @tracked participationStatus = 'Participating';
  @tracked page = 1;
  @tracked limit = 50;

  // List the actual tracked property names so each binds to a matching URL key
  // (camelCase, like the pslf forms controller's `formType`). The previous
  // 'participation-status' string bound a nonexistent property, so the status
  // filter never reached the URL or the route's refreshModel.
  queryParams = ['search', 'sort', 'participationStatus', 'page', 'limit'];
}
